import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import qs from 'qs'

import Meta from "../layout/Meta";
import { Path, PathGenerator } from "../../constants/path";
import { ExternalPath } from "../../constants/path";
import { Link, Button } from "../util/Clickable";

import SearchSmallForm from "../forms/SearchSmallForm";
import FacilityCard from "./FacilityCard";

import { settings } from "../../assets/settings";

class Search extends Component {

  state = {
    query: null,
  }

  componentWillMount = () => {
    this.setState({
      query: null
    }, () => {
      this.locationToQuery(this.props.location);
    });
  }

  componentWillReceiveProps = (nextProps) => {
    
    if( this.props.location.pathname != nextProps.location.pathname || this.props.location.search != nextProps.location.search ){
      this.locationToQuery(nextProps.location);
    }
  }

  locationToQuery = (location) => {
    const query = qs.parse(location.search.replace("?", ""));

    this.setState({
      query: Object.assign({}, settings.search_default(), query)
    })
  }


  render = () => {
    return (
      <div>
        <div className="uk-grid-small uk-flex-middle" data-uk-grid>
          <div className="uk-width-expand">
            <h2>施設検索</h2>
          </div>
        </div>
        <div id="search-base" className="uk-padding-small uk-background-muted uk-margin">
          {
            this.state.query && (
              <SearchSmallForm onSubmit={ (values) => {
                const param = qs.stringify(values);
                this.props.history.push( this.props.location.pathname + "?" + param );
              }} initialValues={this.state.query} />
            )
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    constant: state.constant
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
  }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search))